import React, { useEffect, useState, useContext } from "react";
import { EnvironmentContext } from "../../EnvironmentContext";
import apiconfig from "../../config/config";
import { Toolbar } from "@mui/material";
import { PaginationComponent, DataGridComponent } from "../../Components/PaginationComponent";
import { useNavigate } from "react-router-dom";
import APIServices from "../../services/APIServices";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import "moment-timezone/data/packed/latest.json";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import RefreshIcon from '@mui/icons-material/Refresh';
import AlertComponent from "../../Components/Alert/Alert";
import { setAccessToken } from '../../Redux/Actions';

const BookingManagement = () => {
  const { environment } = useContext(EnvironmentContext)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.accessToken);
  const [updateDetails, setUpdateDetails] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [refundStatusUpdate, setRefundStatusUpdate] = useState(false)
  const [notAttended, setNotAttended] = useState([])
  const totalEventsCount = useSelector((state) => state.totalEventsCount);


  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));
    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }
    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      setIsLoading(true);
      APIServices.setAuthToken(tokenToUse);
      const url = environment === "Production"
        ? apiconfig.production.apiBaseUrl
        : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);
      APIServices.reasonForUnattended()
        .then((res) => {
          setIsLoading(false)
          setNotAttended(res.data.Events)
        })
        .catch((err) => {
          setIsLoading(false)
          alert('Getting err while fetching not attended list , try after some time')
          console.log("unattend err:", err)
        })
    }
  }, [environment, dispatch, updateDetails, accessToken, navigate]);

  const columns = [
    {
      field: "attendee_name",
      headerName: "Attendee name",
      width: 200,
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
    },
    {
      field: "ID_event",
      headerName: "Event ID",
      width: 150,
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
    },
    {
      field: "booking_id",
      headerName: "Booking ID",
      width: 200,
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
    },
    {
      field: "amount_paid",
      headerName: "Amount paid",
      width: 150,
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
    },
    {
      field: "requested_date",
      headerName: "Requested date",
      width: 180,
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
    },
    {
      field: "refund_status",
      headerName: "Refund status",
      width: 250, // Increased width to accommodate button
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      headerClassName: "custom-header",
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 10 }}>{params.value}</span>
          {(params.value === 'PROCESSING' || params.value === 'PENDING') && (
            <RefreshIcon
              style={{ cursor: 'pointer' }}
              onClick={() => handleRefreshRefundStatus(params.row?._id)}
            />
          )}
        </div>
      ),
    },
    {
      field: "reason_unattended",
      headerName: "Reason",
      width: 200,
      cellClassName: (params) => params.row?.reqViewed ? 'orgViewed' : 'notViewd',
      // cellClassName: (params) => params.row?.reqViewed ? 'notViewd' : 'orgViewed',
      headerClassName: "custom-header",
    },
    {
      field: "actions",
      width: 150,
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <RemoveRedEyeIcon
            style={{ cursor: 'pointer' }}
            onClick={() =>
              handleButtonClick(
                params.row?.ID_event,
                params.row?.userId,
                params.row?.booking_id,
                params.row?.booking_datetime,
                params.row?._id,
                params.row?.event_id
              )
            }
          />
        </div>
      ),
    },
  ];

  const completedRefundsCount = notAttended.reduce((totalCount, event) => {
    const completedCount = event.participants.filter(participant => participant.refund_status === "completed").length;
    return totalCount + completedCount;
  }, 0);


  const rows = notAttended.flatMap(event => {
    return event.participants
      .filter(participant => participant.reason_unattended) // Ensure only "not attended" participants
      .map((participant, index) => {
        const [date, time] = participant?.refund_requested_datetime || [];
        const formattedDate = date ? moment(date, "DD-MM-YYYY").format("DD/MM/YYYY") : "Invalid date";
        return {
          id: `${event.ID_event}-${index}`,
          _id: participant._id,
          ID_event: event.ID_event,
          attendee_name: `${participant?.first_name} ${participant?.last_name}`.trim() || participant?.full_name,
          userId: participant?.user_id?._id,
          amount_paid: participant?.amount_paid,
          requested_date: formattedDate,
          refund_status: participant?.refund_status,
          reason_unattended: participant?.reason_unattended,
          booking_id: participant?.booking_id,
          booking_datetime: participant?.booking_datetime,
          event_id: event._id,
          reqViewed: participant?.refund_request_viewed
        };
      });
  });


  const handleButtonClick = (eventId, userId, booking_id, booking_datetime, objectId, event_id) => {
    navigate(`/booking-management/bookingdetails/${eventId}`, {
      state: {
        userId: userId,
        bookingId: booking_id,
        bookingDatetime: booking_datetime,
        objectId: objectId,
        eventId: event_id
      },
    });
  };

  const handleRefreshRefundStatus = (participantId) => {
    setIsLoading(true)
    APIServices.updateRefundStatus(participantId)
      .then((response) => {
        setIsLoading(false);
        setRefundStatusUpdate(true)
        setUpdateDetails(Math.random())
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While Fetching Getting Updated Refund Status: ", err);
      });
  }

  return (
    <div className="event-management-bg-container">
      <AlertComponent
        open={refundStatusUpdate}
        severity="success"
        onClose={() => setRefundStatusUpdate(false)}
        text="Refund status updated successfully."
      />
      <div className="travellers-org-container">
        <div className="travellers-org">
          <div className="travells-cont">
            <p className="total-users-para">Total Events</p>
            <h3 className="total-users-heading">{totalEventsCount} </h3>
          </div>
        </div>

        <div className="travellers-org">
          <div className="travells-cont">
            <p className="total-users-para">Total refunds</p>
            <h3 className="total-users-heading">{completedRefundsCount}</h3>
          </div>
        </div>
      </div>
      <main style={{ flexGrow: 1 }}>
        <Toolbar />
        <DataGridComponent columns={columns} rows={rows} rowCount={rows.length} isLoading={isLoading} />
        {/* <PaginationComponent
          columns={columns}
          rows={rows}
          isLoading={isLoading}
          paginationModel={paginationModel}
          paginationMeta={{ hasNextPage }}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={rows.length}
        /> */}
      </main>
    </div>
  );
};

export default BookingManagement;
